module.exports = __webpack_public_path__ + "img/spokesperson_25.5d88c1e9.png";